import React from "react";
import {FormattedMessage} from "react-intl";
import Amount from "../Utils/Amount";
import Button from "../Utils/UI/Button";
import classes from "./styles.module.css";

function PayControls({pan, cardHolder, phone, email, amount, commission, balance, onSendForm, isLoading}) {
    const total = Number(amount) + Number(commission);
    const isInsufficient = balance && balance.balance !== undefined && Number(balance.balance) < total;

    return (
        <div className={classes.Card}>
            <div className={classes.Content}>
                <h5 className={classes.Title}>
                    <FormattedMessage id="PayControls.title" defaultMessage="Данные выплаты"/>
                </h5>

                <div className={classes.Grid}>
                    <div className={classes.Item}>
                        <span className={classes.Label}>
                            <FormattedMessage id="PayControls.label.card" defaultMessage="Перевод на карту"/>
                        </span>
                        <span className={classes.Value}>{pan || ""}</span>
                    </div>

                    <div className={classes.Item}>
                        <span className={classes.Label}>
                            <FormattedMessage id="PayControls.label.holder" defaultMessage="Держатель"/>
                        </span>
                        <span className={classes.Value}>{cardHolder || ""}</span>
                    </div>

                    <div className={classes.Item}>
                        <span className={classes.Label}>
                            <FormattedMessage id="PayControls.label.email" defaultMessage="Электронная почта"/>
                        </span>
                        <span className={classes.Value}>{email || ""}</span>
                    </div>

                    <div className={classes.Item}>
                        <span className={classes.Label}>
                            <FormattedMessage id="PayControls.label.phone" defaultMessage="Телефон"/>
                        </span>
                        <span className={classes.Value}>{phone || ""}</span>
                    </div>

                    <div className={classes.Item}>
                        <span className={classes.Label}>
                            <FormattedMessage id="PayControls.label.amount" defaultMessage="Сумма"/>
                        </span>
                        <span className={classes.Value}>
                            <Amount amount={amount} currency={balance && balance.currency}/>
                        </span>
                    </div>

                    <div className={classes.Item}>
                        <span className={classes.Label}>
                            <FormattedMessage id="PayControls.label.commission" defaultMessage="Комиссия"/>
                        </span>
                        <span className={classes.Value}>
                            <Amount amount={commission} currency={balance && balance.currency}/>
                        </span>
                    </div>

                    <div className={classes.Item}>
                        <span className={classes.Label}>
                            <FormattedMessage id="PayControls.label.balance" defaultMessage="Баланс"/>
                        </span>
                        <span className={`${classes.Value} ${isInsufficient ? classes.Error : classes.Success}`}>
                            {balance && balance.balance !== undefined ? (
                                <Amount amount={balance.balance} currency={balance.currency}/>
                            ) : (
                                <Amount amount={0} currency={balance && balance.currency}/>
                            )}
                        </span>
                    </div>
                </div>
            </div>

            <div className={classes.Footer}>
                <Button
                    onClick={onSendForm}
                    isLoading={isLoading}
                    label={"PayControls.btn.send"}
                    icon="banknote"
                    accessRight="TRANSACTION_CANCELLING"
                />
            </div>
        </div>
    );
}

export default PayControls;



// WEBPACK FOOTER //
// ./src/Components/PayControls/index.js